import React from 'react';
import { Router, hashHistory } from 'react-router';
import routes from '../routes/routes';

export default (props) => {
  return (
    <Router history={hashHistory} >
      {routes}
    </Router>
  );
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/LoginPcApp/startup/LoginPcApp.jsx